"use client";

import { c as _c } from "react/compiler-runtime";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "@xefi/x-react/form";
import { useTranslation } from "react-i18next";
type Props = {
  value: string;
  onChange: (value: string) => void;
};
export default function PaymentsSearchInput(t0) {
  const $ = _c(14);
  const {
    value,
    onChange
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("paymentsReceived.actions.search");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("paymentsReceived.actions.search");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faSearch} className="h-4 w-4 text-foreground-400 dark:!text-white" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onChange) {
    t4 = () => onChange("");
    $[5] = onChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      inputWrapper: "h-[34px] min-h-[34px] dark:border dark:border-[#3a3a3a] dark:bg-[#2b2b2b]",
      input: "dark:!text-white dark:placeholder:!text-white"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onChange || $[9] !== t1 || $[10] !== t2 || $[11] !== t4 || $[12] !== value) {
    t6 = <Input aria-label={t1} placeholder={t2} isClearable={true} startContent={t3} value={value} onValueChange={onChange} onClear={t4} className="w-[240px]" classNames={t5} />;
    $[8] = onChange;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}